import axios from 'axios';

import { USER_LOGGED_IN, USER_LOGGING_IN, OIDC_WELLKNOWN_FETCHED, FETCHING_AUTH_TOKEN } from '../../../actions';
import { API_URL } from '../../../utils/constant';

export const MFA_REQUIRED = 'MFA_REQUIRED';
export const MFA_VERIFYING = 'MFA_VERIFYING';
export const MFA_VERIFIED = 'MFA_VERIFIED';
export const MFA_RESENDING = 'MFA_RESENDING';
export const MFA_RESENT = 'MFA_RESENT';

export const doUserLogin = async (props, dispatch) => {
	try {
		dispatch({
			type: USER_LOGGING_IN,
			payload: null
		});
		const response = await axios.post(`${API_URL}/login`, props);

		// Check if MFA is required
		if (response.data?.data?.mfaRequired) {
			dispatch({
				type: MFA_REQUIRED,
				payload: response.data,
			});
			return;
		}

		dispatch({
			type: USER_LOGGED_IN,
			payload: response.data,
		});
	} catch (err) {

		if (err.response) {
			return dispatch({
				type: USER_LOGGED_IN,
				payload: err.response.data,
			});
		}

		dispatch({
			type: USER_LOGGED_IN,
			payload: { error: true, message: 'Something went wrong!' },
		});
	}
};

export const verifyOTP = async (props, dispatch) => {
	try {
		dispatch({
			type: MFA_VERIFYING,
			payload: null,
		});
		const response = await axios.post(`${API_URL}/mfa/verify`, props);
		dispatch({
			type: USER_LOGGED_IN,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: MFA_VERIFIED,
				payload: err.response.data,
			});
		}
		dispatch({
			type: MFA_VERIFIED,
			payload: { error: true, message: 'Something went wrong!' },
		});
	}
};

export const resendOTP = async (props, dispatch) => {
	try {
		dispatch({
			type: MFA_RESENDING,
			payload: null,
		});
		const response = await axios.post(`${API_URL}/mfa/resend`, props);
		dispatch({
			type: MFA_RESENT,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: MFA_RESENT,
				payload: err.response.data,
			});
		}
		dispatch({
			type: MFA_RESENT,
			payload: { error: true, message: 'Something went wrong!' },
		});
	}
};


export const doMicrosoftLogin = async (props, dispatch) => {
	try {
		dispatch({
			type: USER_LOGGING_IN,
			payload: null
		});
		const response = await axios.post(`${API_URL}/microsoft/login`, props);
		dispatch({
			type: USER_LOGGED_IN,
			payload: response.data,
		});
	} catch (err) {

		if (err.response) {
			return dispatch({
				type: USER_LOGGED_IN,
				payload: err.response.data,
			});
		}

		dispatch({
			type: USER_LOGGED_IN,
			payload: { error: true, message: 'Something went wrong!' },
		});
	}
};

export const initiateOidcLogin = async (props, dispatch) => {
	try {
		dispatch({
			type: USER_LOGGING_IN,
			payload: null
		});
		const param = props.org ? `org=${encodeURIComponent(props.org)}` : `email=${encodeURIComponent(props.email)}`;
		const response = await axios.get(`${API_URL}/oidc/login?${param}`);
		if (response.data?.code_verifier) {
			localStorage.setItem('pkceCodeVerifier', response.data.code_verifier);
		}
		if (response.data?.nonce) {
			localStorage.setItem('oidcNonce', response.data.nonce);
		}
		dispatch({
			type: OIDC_WELLKNOWN_FETCHED,
			payload: response.data
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: OIDC_WELLKNOWN_FETCHED,
				payload: err.response.data
			});
		}
		dispatch({
			type: OIDC_WELLKNOWN_FETCHED,
			payload: { error: true, message: 'Something went wrong!' }
		});
	}
};

export const tokenExchange = async (props, dispatch) => {
	try {
		dispatch({
			type: FETCHING_AUTH_TOKEN,
			payload: null
		});
		const response = await axios.post(`${API_URL}/token_exchange`, props);
		dispatch({
			type: FETCHING_AUTH_TOKEN,
			payload: response.data
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: FETCHING_AUTH_TOKEN,
				payload: err.response.data
			});
		}
		dispatch({
			type: FETCHING_AUTH_TOKEN,
			payload: { error: true, message: 'Something went wrong!' }
		});
	}
};